<script setup>
import Toggle from '@/components/ui/toggle.vue'

// I18N
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  notificationType: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false
  },
})

const model = defineModel()
</script>

<template>
  <div class="mb-8 flex flex-row">
    <div class="grow">
      <p class="font-semibold">{{ t(`settings.notification_settings_section.${notificationType}`) }}</p>
      <p class="p-2">{{ t(`settings.notification_settings_section.${notificationType}_subtext`) }}</p>
    </div>
    <div>
      <toggle :disabled="disabled" v-model="model"></toggle>
    </div>
  </div>
</template>